export const Star = ({ className = "" }) => (
  <svg viewBox="0 0 200 200" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="star-light" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#FFFFFF" />
        <stop offset="0.5" stopColor="#E6E6E6" />
        <stop offset="1" stopColor="#B4B4B4" />
      </linearGradient>
      <linearGradient id="star-dark" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#9A9A9A" />
        <stop offset="0.5" stopColor="#6A6A6A" />
        <stop offset="1" stopColor="#3A3A3A" />
      </linearGradient>
    </defs>
    <g>
      <path d="M100 0 L94 92 L100 100 Z" fill="url(#star-light)" />
      <path d="M100 0 L106 92 L100 100 Z" fill="url(#star-dark)" />
      <path d="M100 200 L94 108 L100 100 Z" fill="url(#star-light)" />
      <path d="M100 200 L106 108 L100 100 Z" fill="url(#star-dark)" />
      <path d="M8 100 L92 96 L100 100 Z" fill="url(#star-light)" />
      <path d="M8 100 L92 104 L100 100 Z" fill="url(#star-dark)" />
      <path d="M192 100 L108 96 L100 100 Z" fill="url(#star-light)" />
      <path d="M192 100 L108 104 L100 100 Z" fill="url(#star-dark)" />
      <path d="M56 56 L93 89 L100 100 Z" fill="url(#star-light)" />
      <path d="M56 56 L89 93 L100 100 Z" fill="url(#star-dark)" />
      <path d="M144 56 L107 89 L100 100 Z" fill="url(#star-light)" />
      <path d="M144 56 L111 93 L100 100 Z" fill="url(#star-dark)" />
      <path d="M56 144 L89 107 L100 100 Z" fill="url(#star-light)" />
      <path d="M56 144 L93 111 L100 100 Z" fill="url(#star-dark)" />
      <path d="M144 144 L111 107 L100 100 Z" fill="url(#star-light)" />
      <path d="M144 144 L107 111 L100 100 Z" fill="url(#star-dark)" />
    </g>
  </svg>
);
